export default function CTASection() {
  return (
    <section id="cta" className="relative w-full py-14 md:py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20editorial%20overhead%20shot%20of%20a%20beautifully%20organized%20creative%20workspace%20with%20curated%20fashion%20items%20art%20supplies%20and%20a%20tablet%20displaying%20colorful%20product%20catalog%2C%20warm%20cream%20and%20terracotta%20tones%2C%20soft%20natural%20daylight%2C%20sage%20green%20botanical%20accents%2C%20harmonious%20and%20inspiring%20atmosphere%2C%20modern%20lifestyle%20photography%20with%20gentle%20shadows%20and%20organic%20flow&width=1800&height=800&seq=cta-bg-v2-01&orientation=landscape"
          alt="Kakobuy Spreadsheet"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/90 via-background-50/70 to-background-50/95"></div>

      <div className="relative z-10 max-w-[700px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950 mb-4">
          Gotowy na zakupy z Kakobuy?
        </h2>
        <p className="text-sm md:text-base text-foreground-600 mb-8 max-w-[500px] mx-auto leading-relaxed">
          Uzyskaj dostęp do pełnego Kakobuy Spreadsheet i znajdź najlepsze produkty już dziś. Tysiące produktów czeka na Ciebie.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-md text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          Otwórz Kakobuy Spreadsheet
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </section>
  );
}